import { render, staticRenderFns } from "./PreviewTemplate.vue?vue&type=template&id=19f4f4a5&scoped=true&"
import script from "./PreviewTemplate.vue?vue&type=script&lang=js&"
export * from "./PreviewTemplate.vue?vue&type=script&lang=js&"
import style0 from "./PreviewTemplate.vue?vue&type=style&index=0&id=19f4f4a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f4f4a5",
  null
  
)

export default component.exports